import { motion } from "framer-motion";
import { PhoneCall, CalendarCheck, GraduationCap, Award, ClipboardList } from "lucide-react";

const STEPS = [
  {
    icon: PhoneCall,
    title: "Contattaci",
    body: "Scrivici o chiamaci: capiamo insieme il corso giusto per te o per la tua azienda.",
  },
  {
    icon: CalendarCheck,
    title: "Scegli la data",
    body: "Ti proponiamo le date disponibili, in sede a Frosinone o presso di te in tutta Italia.",
  },
  {
    icon: GraduationCap,
    title: "Impari sul campo",
    body: "Teoria e pratica con manichini e defibrillatori trainer, guidato da istruttori titolati.",
  },
  {
    icon: Award,
    title: "Ottieni l'attestato",
    body: "Ricevi la certificazione ARES 118 / AHA, riconosciuta e valida due anni.",
  },
];

const STEPS_AZIENDE = [
  {
    icon: PhoneCall,
    title: "Contattaci",
    body: "Raccontaci le esigenze della tua azienda e il servizio di cui hai bisogno.",
  },
  {
    icon: CalendarCheck,
    title: "Scegli la data",
    body: "Valutiamo le tue necessità e ti proponiamo le date disponibili: potrai svolgere il corso presso la nostra sede di Frosinone o direttamente nella tua azienda, in tutta Italia.",
  },
  {
    icon: ClipboardList,
    title: "Organizziamo il percorso",
    body: "Pianifichiamo consulenza, formazione o certificazione, definendo insieme modalità e tempistiche.",
  },
  {
    icon: Award,
    title: "Ottieni l'attestato",
    body: "Seguiamo ogni fase del percorso e ti forniamo la documentazione e gli attestati previsti.",
  },
];

export const HowItWorks = ({ variant }) => {
  const isAziende = variant === "aziende";
  const steps = isAziende ? STEPS_AZIENDE : STEPS;
  return (
    <section
      id="come-funziona"
      data-testid="how-section"
      className="bg-brand-red text-white py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <h2 className="font-heading font-bold text-4xl md:text-6xl tracking-tighter leading-none">
            Come   funziona
          </h2>
          <p className="max-w-sm text-sm text-white/80 leading-relaxed">
            {isAziende
              ? "Dal primo contatto alla soluzione più adatta alla tua azienda. Ti accompagniamo in ogni fase del percorso."
              : "Dal primo contatto all'attestato in quattro semplici passi. Ti accompagniamo in tutto il percorso."}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`step-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.1 }}
                className="relative"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-heading font-black text-6xl text-white/25 leading-none">
                    0{i + 1}
                  </span>
                  <Icon size={30} className="text-white" />
                </div>
                <div className="h-px w-full bg-white/30 mb-5" />
                <h3 className="font-heading font-bold text-2xl mb-2">{s.title}</h3>
                <p className="text-sm text-white/80 leading-relaxed">{s.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
